import { NavLink } from 'react-router-dom';
import { useState } from 'react';
import styles from './Navigation.module.css';
import { useTranslation } from 'react-i18next';
import langImg from "./languageImg.png"

export const Navigation = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const { t, i18n } = useTranslation();

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  const closeMenu = () => {
    setMenuOpen(false);
  };

  return (
    <nav className={styles.navigation}>
      <div className={styles['nav-container']}>
        <NavLink to="/" className={styles.logo} onClick={closeMenu}>
          Ondřej Wislocki
        </NavLink>

        
        
        <button 
          className={`${styles['hamburger']} ${menuOpen ? styles.active : ''}`}
          onClick={toggleMenu}
          aria-label="Toggle navigation menu"
        >
          <span></span>
          <span></span>
          <span></span>
        </button>

        <ul className={`${styles['nav-menu']} ${menuOpen ? styles.open : ''}`}>
          
          <li>
            <NavLink
              to="/"
              className={({ isActive }) =>
                isActive ? `${styles['nav-link']} ${styles.active}` : styles['nav-link']
              }
              onClick={closeMenu}
            >
              {t("nav.home")}
            </NavLink>
          </li>
          <li>
            <NavLink
              to="/about"
              className={({ isActive }) =>
                isActive ? `${styles['nav-link']} ${styles.active}` : styles['nav-link']
              }
              onClick={closeMenu}
            >
              {t("nav.about")}
            </NavLink>
          </li>
          <li>
            <NavLink
              to="/projects"
              className={({ isActive }) =>
                isActive ? `${styles['nav-link']} ${styles.active}` : styles['nav-link']
              }
              onClick={closeMenu}
            >
              {t("nav.projects")}
            </NavLink>
          </li>
          <li>
            <NavLink
              to="/contact"
              className={({ isActive }) =>
                isActive ? `${styles['nav-link']} ${styles.active}` : styles['nav-link']
              }
              onClick={closeMenu}
            >
              {t("nav.contact")}
            </NavLink>
          </li>
          <li>
            <button className={styles.langBtn+" "+styles['nav-link']}
          onClick={()=> i18n.changeLanguage(i18n.language === 'en' ? 'cs' : 'en')}
        >
            {i18n.language === 'en' ? 'EN' : 'CZ'} <img src={langImg} alt="" />
        </button>
          </li>
        </ul>
      </div>
    </nav>
  );
};
